module.exports = __webpack_public_path__ + "static/SessunLogo-2c31af2e86d4bd96d7e47b36d59648f1.png";